/**
 * The selected Reports period - a fiscal year, or one quarter of it - in the
 * forms the tabs need: words for a heading, a tag for a filename, and the
 * inclusive local-time window for anything counted by date.
 */
import { fiscalYearLabel, fiscalYearShortLabel, fiscalYearRange, fiscalMonthRange } from '../../utils/fiscalYear.mjs';
import { QUARTERS, quarterLabel } from './aggregate.mjs';

const whole = (quarter) => !quarter || quarter === 'all';

/** "FY26 (Sep 2025 - Aug 2026)" or "Q2 FY26 (Dec 2025 - Feb 2026)" */
export const periodText = (fy, quarter) => (whole(quarter) ? fiscalYearLabel(fy) : quarterLabel(quarter, fy));

/** "FY26" or "FY26_Q2", for filenames. */
export const periodTag = (fy, quarter) => `${fiscalYearShortLabel(fy)}${whole(quarter) ? '' : `_Q${quarter}`}`;

/** { from, to } Dates covering the period, first instant to last. */
export const periodWindow = (fy, quarter) => {
  if (whole(quarter)) return fiscalYearRange(fy);
  const months = QUARTERS.find(x => x.q === Number(quarter))?.months;
  if (!months) return fiscalYearRange(fy);
  return {
    from: fiscalMonthRange(fy, months[0]).from,
    to: fiscalMonthRange(fy, months[months.length - 1]).to,
  };
};

/**
 * The region a download or heading should name: the one selected, or - for
 * someone who sees a single region and so has no picker - that region, which
 * the server echoes back.
 */
export const namedRegion = (scope, served) => {
  if (scope.region && scope.region !== 'all') return scope.region;
  if (!scope.isGlobal) return served || scope.userRegion || 'all';
  return 'all';
};
